// extracted by mini-css-extract-plugin
module.exports = {"container":"Settings_container__1Ee61"};